import { render, staticRenderFns } from "./GlReport.vue?vue&type=template&id=56e47d7e&"
import script from "./GlReport.vue?vue&type=script&lang=js&"
export * from "./GlReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports